//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/**
 * Gets the status of the Assessment  (i.e. Pending, Complete)
 * Complete should only be used if the Assessment was actually completed, everything else is pending.
 */
export const AssessmentRequestStatus = {
    /** Pending Status, anything that wasn't completed. */
    Pending: 0,

    /** Complete Status, only use if assessment was actually completed */
    Complete: 1
} as const;

/**
 * Gets the status of the Assessment  (i.e. Pending, Complete)
 * Complete should only be used if the Assessment was actually completed, everything else is pending.
 */
export const AssessmentRequestStatusDescription: Record<number, string> = {
    0: "Pending",

    1: "Complete"
};

/**
 * Gets the status of the Assessment  (i.e. Pending, Complete)
 * Complete should only be used if the Assessment was actually completed, everything else is pending.
 */
export type AssessmentRequestStatus = typeof AssessmentRequestStatus[keyof typeof AssessmentRequestStatus];
